import { render, staticRenderFns } from "./CustomerManager.vue?vue&type=template&id=7cb35d02&scoped=true&"
import script from "./CustomerManager.vue?vue&type=script&lang=js&"
export * from "./CustomerManager.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManager.vue?vue&type=style&index=0&id=7cb35d02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb35d02",
  null
  
)

export default component.exports